<div class="row col-24 legend">
	<div *ngFor="let group of groupingConfiguration; let i = index" class="category">
		<ng-container *ngIf="chartData[i]">
			<div class="legend-heading">
				{{ group.heading }}
				<span class="legend-sub-heading"> {{ group.subHeading }} </span>
			</div>
			<div *ngIf="isTableDataPerPortfolio">
				<ng-container *ngTemplateOutlet="seriesLegend; context: { series: chartData[i]?.tableData, i }"></ng-container>
			</div>
			<div *ngIf="!isTableDataPerPortfolio">
				<ng-container *ngTemplateOutlet="seriesLegend; context: { series: (chartData[i]?.tableData)[0]?.headersY, i }"></ng-container>
			</div>
		</ng-container>
	</div>
</div>

<ng-template #seriesLegend let-series="series" let-i="i">
	<div *ngFor="let series of series; let j = index" class="series-label">
		<div *ngIf="seriesLabelIcon === SeriesLabelIcon.DASH" [ngStyle]="{ color: seriesColors[i][j] }" class="label-icon-dash">――</div>
		<div *ngIf="seriesLabelIcon === SeriesLabelIcon.CIRCLE" [ngStyle]="{ 'background-color': seriesColors[i][j] }" class="label-icon-circle"></div>
		<div *ngIf="isTableDataPerPortfolio">
			<ng-container *ngTemplateOutlet="labelTemplate; context: { label: series?.headersY?.[0] }"></ng-container>
		</div>
		<div *ngIf="!isTableDataPerPortfolio">
			<ng-container *ngTemplateOutlet="labelTemplate; context: { label: series }"></ng-container>
		</div>
	</div>
</ng-template>
<ng-template #labelTemplate let-label="label">
	<p class="label-text">{{ label }}</p>
</ng-template>
